export class UserFormEditTypes {
    static detail = 'detail';
    static permissions = 'permissions';
}
